import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule) },
];
